<div class="page-container reserve-business-compare-content">
  <!--title 標題-->
  <div class="page-title-block">
    <h2 class="page-title">
      {{ 'business-reserve-compare.title' | translate }}
    </h2>
    <button mat-button class="btn-text-primary btn-size-m" (click)="downloadEnterprisePlan()">
      {{ 'reserve-result.download-healthPlan-usual' | translate }}
      <img width="24" height="24" src="assets/img/download-usual.png" alt="download" />
    </button>
  </div>

  <!--  方案列表 -->
  <div class="business-package-container">
    <h3 class="business-package-title">
      {{ 'business-reserve-compare.package-list' | translate }}
    </h3>
    <!-- 比較方案一 -->
    @if (firstComparedPackage) {
      <div class="btn-card">
        <p class="btn-card-title">{{ firstComparedPackageDetail?.packageName }}</p>
        <p class="btn-card-price">
          <label>$</label>{{ firstComparedPackageDetail?.price | numberComma }}
        </p>
        <div class="btn-group">
          <button
            mat-button
            class="btn-outline-primary btn-size-l"
            (click)="replacePackage(0)"
          >
            <span>{{
              'business-reserve-compare.replace-package' | translate
            }}</span>
            <img
              width="24"
              height="24"
              ngSrc="assets/img/i-arrows-switch.svg"
              alt=""
            />
          </button>
          <button
            mat-button
            class="btn-text-underline btn-size-s"
            (click)="replacePackage(0)"
          >
            <span>{{
              'business-reserve-compare.replace-package' | translate
            }}</span>
          </button>
          <button
            mat-button
            class="btn-fill-primary btn-size-l"
            (click)="reservePackage(firstComparedPackageDetail!)"
          >
            {{ 'business-reserve-compare.reserve-package' | translate }}
          </button>
        </div>
      </div>
    } @else {
      <div class="btn-card btn-select" (click)="replacePackage(0)">
        <button mat-button>
          {{ 'business-reserve-compare.select-compare-package' | translate }}
        </button>
      </div>
    }

    <!--比較方案二-->
    @if (secondComparedPackage) {
      <div class="btn-card">
        <p class="btn-card-title">{{ secondComparedPackageDetail?.packageName }}</p>
        <p class="btn-card-price">
          <label>$</label>{{ secondComparedPackageDetail?.price | numberComma }}
        </p>
        <div class="btn-group">
          <button
            mat-button
            class="btn-outline-primary btn-size-l"
            (click)="replacePackage(1)"
          >
            <span>{{
              'business-reserve-compare.replace-package' | translate
            }}</span>
            <img
              width="24"
              height="24"
              ngSrc="assets/img/i-arrows-switch.svg"
              alt=""
            />
          </button>
          <button
            mat-button
            class="btn-text-underline btn-size-s"
            (click)="replacePackage(1)"
          >
            <span>{{
              'business-reserve-compare.replace-package' | translate
            }}</span>
          </button>
          <button
            mat-button
            class="btn-fill-primary btn-size-l"
            (click)="reservePackage(secondComparedPackageDetail!)"
          >
            {{ 'business-reserve-compare.reserve-package' | translate }}
          </button>
        </div>
      </div>
    } @else {
      <div class="btn-card btn-select" (click)="replacePackage(1)">
        <button mat-button>
          <div class="btn-img-block">
            <img
              width="48"
              height="48"
              ngSrc="assets/img/i-circle-add.svg"
              alt=""
            />
            <span>{{
              'business-reserve-compare.select-compare-package' | translate
            }}</span>
          </div>
        </button>
      </div>
    }

    <!--比較方案三-->
    @if (thirdComparedPackage) {
      <div class="btn-card">
        <p class="btn-card-title">{{ thirdComparedPackageDetail?.packageName }}</p>
        <p class="btn-card-price">
          <label>$</label>{{ thirdComparedPackageDetail?.price | numberComma }}
        </p>
        <div class="btn-group">
          <button
            mat-button
            class="btn-outline-primary btn-size-l"
            (click)="replacePackage(2)"
          >
            <span>{{
              'business-reserve-compare.replace-package' | translate
            }}</span>
            <img
              width="24"
              height="24"
              ngSrc="assets/img/i-arrows-switch.svg"
              alt=""
            />
          </button>
          <button
            mat-button
            class="btn-text-underline btn-size-s"
            (click)="replacePackage(2)"
          >
            <span>{{
              'business-reserve-compare.replace-package' | translate
            }}</span>
          </button>
          <button
            mat-button
            class="btn-fill-primary btn-size-l"
            (click)="reservePackage(thirdComparedPackageDetail!)"
          >
            {{ 'business-reserve-compare.reserve-package' | translate }}
          </button>
        </div>
      </div>
    } @else {
      <div class="btn-card btn-select" (click)="hasSecondComparedPackage ? replacePackage(2) : null" [class.disabled]="!hasSecondComparedPackage">
        <button mat-button [disabled]="!hasSecondComparedPackage">
          <div class="btn-img-block">
            <img
              width="48"
              height="48"
              ngSrc="assets/img/i-circle-add.svg"
              alt=""
            />
            <span>{{
              'business-reserve-compare.select-compare-package' | translate
            }}</span>
          </div>
        </button>
      </div>
    }
  </div>

  <!--分類檢項-->
  <div class="reserve-table-block">
    @for (deptName of deptNames; let i = $index; track i) {
      <div class="plan-table">
        <!-- table-header 表頭-->
        <div
          class="plan-table-header"
          (click)="isDeptNameOpen.set(deptName, !isDeptNameOpen.get(deptName))"
        >
          <div class="plan-table-header-title">{{ deptName }}</div>
          <button mat-button class="btn-icon">
            <img
              width="32"
              height="32"
              alt=""
              [ngSrc]="
                isDeptNameOpen.get(deptName)
                  ? 'assets/img/i-arrow-up.svg'
                  : 'assets/img/i-arrow-down.svg'
              "
            />
          </button>
        </div>
        <!-- table-body 內文-->
        @if (isDeptNameOpen.get(deptName)) {
          <div class="plan-table-body">
            @for (
              businessExamInfo of deptNameExamInfoMap.get(deptName);
              track $index
            ) {
              <div class="plan-table-list">
                <div class="plan-table-list-name">
                  <span>{{ businessExamInfo.examName }}</span>
                  <button
                    mat-icon-button
                    type="button"
                    class="btn-icon btn-info"
                    (click)="showExamDialog(businessExamInfo)"
                  >
                    <img
                      width="14"
                      height="14"
                      ngSrc="assets/img/i-info.svg"
                      alt=""
                    />
                  </button>
                </div>
                <div class="plan-table-list-item">
                  <div class="plan-table-data">
                    @if (
                      firstComparedPackageContainsExamInfo(
                        businessExamInfo.examItem
                      )
                    ) {
                      <img
                        width="20"
                        height="20"
                        ngSrc="assets/img/i-check-green.svg"
                        alt=""
                        class="icon-black"
                      />
                    }
                  </div>
                  <div class="plan-table-data">
                    @if (
                      secondComparedPackageContainsExamInfo(
                        businessExamInfo.examItem
                      )
                    ) {
                      <img
                        width="20"
                        height="20"
                        ngSrc="assets/img/i-check-green.svg"
                        alt=""
                        class="icon-black"
                      />
                    }
                  </div>
                  <div class="plan-table-data">
                    @if (
                      thirdComparedPackageContainsExamInfo(
                        businessExamInfo.examItem
                      )
                    ) {
                      <img
                        width="20"
                        height="20"
                        ngSrc="assets/img/i-check-green.svg"
                        alt=""
                        class="icon-black"
                      />
                    }
                  </div>
                </div>
              </div>
            }
            @for (
              groupInfo of deptNameGroupInfoMap.get(deptName);
              track $index
            ) {
              <div class="plan-table-list group-list">
                <div class="plan-table-list-name">
                  <span>{{ groupInfo.groupTitleName }}</span>
                  <button
                    mat-icon-button
                    type="button"
                    class="btn-icon btn-info"
                    (click)="showGroupInfoDialog(groupInfo)"
                  >
                    <img
                      width="14"
                      height="14"
                      ngSrc="assets/img/i-info.svg"
                      alt=""
                    />
                  </button>
                </div>
                <!-- <div class="plan-table-list-item">
                  <div class="plan-table-data">
                    <p>{{ firstComparedPackageGroupInfoText(groupInfo) }}</p>
                  </div>
                  <div class="plan-table-data">
                    <p>{{ secondComparedPackageGroupInfoText(groupInfo) }}</p>
                  </div>
                  <div class="plan-table-data">
                    <p>{{ thirdComparedPackageGroupInfoText(groupInfo) }}</p>
                  </div>
                </div> -->
              </div>
            }
          </div>
        }
      </div>
    }
    <div class="plan-table">
      <div class="plan-table-header"
        (click)="isCombinationOpen = !isCombinationOpen"
      >
        <div class="plan-table-header-title">
          {{ 'business-reserve-compare.combo-package' | translate }}
        </div>
        <button mat-button class="btn-icon">
          <img
            width="32"
            height="32"
            alt=""
            [ngSrc]="
              isCombinationOpen
                ? 'assets/img/i-arrow-up.svg'
                : 'assets/img/i-arrow-down.svg'
            "
          />
        </button>
      </div>
      <div class="plan-table-body">
        @if (isCombinationOpen) {
          @for (item of sortedCombinationItemsByPackage; track item.sortOrder) {
            @if (item.type === 'group') {
              <div class="plan-table-list group-list" [class.exam-choose-first]="item.itemIndex === 0" [class.exam-choose-item]="item.itemIndex > 0">
                <div class="plan-table-list-name">
                  @if (item.itemIndex === 0) {
                    <!-- 手機版：將檢項合併顯示 -->
                    <div class="exam-items-container mobile-all-items" [class.mobile-hidden]="false">
                      @for (groupItem of item.parentData.groupList; track groupItem.groupItem || $index) {
                        <div class="exam-item-row">
                          @for (examItem of groupItem.examItemList; track examItem.examItem || $index) {
                            <div class="exam-item-row">
                              <span>{{ examItem.examName }}</span>
                              <button
                                mat-icon-button
                                type="button"
                                class="btn-icon btn-info"
                                (click)="showExamDialog(examItem)"
                              >
                                <img
                                  width="14"
                                  height="14"
                                  ngSrc="assets/img/i-info.svg"
                                  alt=""
                                />
                              </button>
                            </div>
                          }
                        </div>
                      }
                    </div>
                    <!-- 桌面版：將檢項個別欄位顯示 -->
                    <div class="exam-items-container desktop-single-item">
                      @for (examItem of item.data.examItemList; track examItem.examItem) {
                        <div class="exam-item-row">
                          <span>{{ examItem.examName }}</span>
                          <button
                            mat-icon-button
                            type="button"
                            class="btn-icon btn-info"
                            (click)="showExamDialog(examItem)"
                          >
                            <img
                              width="14"
                              height="14"
                              ngSrc="assets/img/i-info.svg"
                              alt=""
                            />
                          </button>
                        </div>
                      }
                    </div>
                  } @else {
                    <!-- 手機版檢項合併顯示 -->
                    <div class="mobile-hidden">
                      @for (examItem of item.data.examItemList; track examItem.examItem) {
                        <div class="exam-item-row">
                          <span>{{ examItem.examName }}</span>
                          <button
                            mat-icon-button
                            type="button"
                            class="btn-icon btn-info"
                            (click)="showExamDialog(examItem)"
                          >
                            <img
                              width="14"
                              height="14"
                              ngSrc="assets/img/i-info.svg"
                              alt=""
                            />
                          </button>
                        </div>
                      }
                    </div>
                  }
                </div>
                <div class="plan-table-list-item">
                  @if (item.itemIndex === 0) {
                    <div class="plan-table-data" [class.exam-choose-data]="getPackageGroupChooseText(0, item.parentData)" [attr.data-item-count]="item.parentData.groupList.length">
                      @if (getPackageGroupChooseText(0, item.parentData)) {
                        <p>{{ getPackageGroupChooseText(0, item.parentData) }}</p>
                      }
                    </div>
                    <div class="plan-table-data" [class.exam-choose-data]="getPackageGroupChooseText(1, item.parentData)" [attr.data-item-count]="item.parentData.groupList.length">
                      @if (getPackageGroupChooseText(1, item.parentData)) {
                        <p>{{ getPackageGroupChooseText(1, item.parentData) }}</p>
                      }
                    </div>
                    <div class="plan-table-data" [class.exam-choose-data]="getPackageGroupChooseText(2, item.parentData)" [attr.data-item-count]="item.parentData.groupList.length">
                      @if (getPackageGroupChooseText(2, item.parentData)) {
                        <p>{{ getPackageGroupChooseText(2, item.parentData) }}</p>
                      }
                    </div>
                  } @else {
                    <div class="plan-table-data exam-item-empty"></div>
                    <div class="plan-table-data exam-item-empty"></div>
                    <div class="plan-table-data exam-item-empty"></div>
                  }
                </div>
              </div>
            } @else {
              <div class="plan-table-list group-list" [class.exam-choose-first]="item.itemIndex === 0" [class.exam-choose-item]="item.itemIndex > 0">
                <div class="plan-table-list-name">
                  @if (item.itemIndex === 0) {
                    <!-- 手機版：顯示所有檢項 -->
                    <div class="exam-items-container mobile-all-items">
                      @for (examItem of item.parentData.examItemList; track examItem.examItem) {
                        <div class="exam-item-row">
                          <span>{{ examItem.examName }}</span>
                          <button
                            mat-icon-button
                            type="button"
                            class="btn-icon btn-info"
                            (click)="showExamDialog(examItem)"
                          >
                            <img
                              width="14"
                              height="14"
                              ngSrc="assets/img/i-info.svg"
                              alt=""
                            />
                          </button>
                        </div>
                      }
                    </div>
                    <!-- 桌面版：只顯示當前檢項 -->
                    <div class="exam-items-container desktop-single-item">
                      <div class="exam-item-row">
                        <span>{{ item.data.examName }}</span>
                        <button
                          mat-icon-button
                          type="button"
                          class="btn-icon btn-info"
                          (click)="showExamDialog(item.data)"
                        >
                          <img
                            width="14"
                            height="14"
                            ngSrc="assets/img/i-info.svg"
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  } @else {
                    <!-- 手機板顯示所有檢項 -->
                    <div class="mobile-hidden">
                      <span>{{ item.data.examName }}</span>
                      <button
                        mat-icon-button
                        type="button"
                        class="btn-icon btn-info"
                        (click)="showExamDialog(item.data)"
                      >
                        <img
                          width="14"
                          height="14"
                          ngSrc="assets/img/i-info.svg"
                          alt=""
                        />
                      </button>
                    </div>
                  }
                </div>
                <div class="plan-table-list-item">
                  @if (item.itemIndex === 0) {
                    <div class="plan-table-data" [class.exam-choose-data]="getPackageExamChooseText(0, item.parentData)" [attr.data-item-count]="item.parentData.examItemList.length">
                      @if (getPackageExamChooseText(0, item.parentData)) {
                        <p>{{ getPackageExamChooseText(0, item.parentData) }}</p>
                      }
                    </div>
                    <div class="plan-table-data" [class.exam-choose-data]="getPackageExamChooseText(1, item.parentData)" [attr.data-item-count]="item.parentData.examItemList.length">
                      @if (getPackageExamChooseText(1, item.parentData)) {
                        <p>{{ getPackageExamChooseText(1, item.parentData) }}</p>
                      }
                    </div>
                    <div class="plan-table-data" [class.exam-choose-data]="getPackageExamChooseText(2, item.parentData)" [attr.data-item-count]="item.parentData.examItemList.length">
                      @if (getPackageExamChooseText(2, item.parentData)) {
                        <p>{{ getPackageExamChooseText(2, item.parentData) }}</p>
                      }
                    </div>
                  } @else {
                    <div class="plan-table-data exam-item-empty"></div>
                    <div class="plan-table-data exam-item-empty"></div>
                    <div class="plan-table-data exam-item-empty"></div>
                  }
                </div>
              </div>
            }
          }
        }
      </div>
    </div>
  </div>

  <!-- 方案列表:固定列表 -->
  <div
    class="business-package-container fixed-package"
    [class.active]="isTableFixedActive"
  >
    <h3 class="business-package-title">
      <span [@fadeInOut]="animationKey">{{ currentTableHeaderTitle }}</span>
    </h3>
    <!-- 比較方案一 -->
    <div class="business-package-list">
      @if (firstComparedPackage) {
        <div class="btn-card">
          <p class="btn-card-title">{{ firstComparedPackageDetail?.packageName }}</p>
          <p class="btn-card-price">
            <label>$</label>{{ firstComparedPackageDetail?.price | numberComma }}
          </p>
          <div class="btn-group">
            <button
              mat-button
              class="btn-outline-primary btn-size-l"
              (click)="replacePackage(0)"
            >
              <span>{{
                'business-reserve-compare.replace-package' | translate
              }}</span>
              <img
                width="24"
                height="24"
                ngSrc="assets/img/i-arrows-switch.svg"
                alt=""
              />
            </button>
            <button
              mat-button
              class="btn-text-underline btn-size-s"
              (click)="replacePackage(0)"
            >
              <span>{{
                'business-reserve-compare.replace-package' | translate
              }}</span>
            </button>
            <button
              mat-button
              class="btn-fill-primary btn-size-l"
              (click)="reservePackage(firstComparedPackageDetail!)"
            >
              {{ 'business-reserve-compare.reserve-package' | translate }}
            </button>
          </div>
        </div>
      } @else {
        <div class="btn-card btn-select" (click)="replacePackage(0)">
          <button mat-button>
            {{ 'business-reserve-compare.select-compare-package' | translate }}
          </button>
        </div>
      }

      <!--比較方案二-->
      @if (secondComparedPackage) {
        <div class="btn-card">
          <p class="btn-card-title">{{ secondComparedPackageDetail?.packageName }}</p>
          <p class="btn-card-price">
            <label>$</label>{{ secondComparedPackageDetail?.price | numberComma }}
          </p>
          <div class="btn-group">
            <button
              mat-button
              class="btn-text-underline btn-size-s"
              (click)="replacePackage(1)"
            >
              <span>{{
                'business-reserve-compare.replace-package' | translate
              }}</span>
            </button>
            <button
              mat-button
              class="btn-outline-primary btn-size-l"
              (click)="replacePackage(1)"
            >
              <span>{{
                'business-reserve-compare.replace-package' | translate
              }}</span>
              <img
                width="24"
                height="24"
                ngSrc="assets/img/i-arrows-switch.svg"
                alt=""
              />
            </button>
            <button
              mat-button
              class="btn-fill-primary btn-size-l"
              (click)="reservePackage(secondComparedPackageDetail!)"
            >
              {{ 'business-reserve-compare.reserve-package' | translate }}
            </button>
          </div>
        </div>
      } @else {
        <div class="btn-card btn-select" (click)="replacePackage(1)">
          <button mat-button>
            <div class="btn-img-block">
              <img
                width="48"
                height="48"
                ngSrc="assets/img/i-circle-add.svg"
                alt=""
              />
              <span>{{
                'business-reserve-compare.select-compare-package' | translate
              }}</span>
            </div>
          </button>
        </div>
      }

      <!--比較方案三-->
      @if (thirdComparedPackage) {
        <div class="btn-card">
          <p class="btn-card-title">{{ thirdComparedPackageDetail?.packageName }}</p>
          <p class="btn-card-price">
            <label>$</label>{{ thirdComparedPackageDetail?.price | numberComma }}
          </p>
          <div class="btn-group">
            <button
              mat-button
              class="btn-text-underline btn-size-s"
              (click)="replacePackage(2)"
            >
              <span>{{
                'business-reserve-compare.replace-package' | translate
              }}</span>
            </button>
            <button
              mat-button
              class="btn-outline-primary btn-size-l"
              (click)="replacePackage(2)"
            >
              <span>{{
                'business-reserve-compare.replace-package' | translate
              }}</span>
              <img
                width="24"
                height="24"
                ngSrc="assets/img/i-arrows-switch.svg"
                alt=""
              />
            </button>
            <button
              mat-button
              class="btn-fill-primary btn-size-l"
              (click)="reservePackage(thirdComparedPackageDetail!)"
            >
              {{ 'business-reserve-compare.reserve-package' | translate }}
            </button>
          </div>
        </div>
      } @else {
        <div class="btn-card btn-select" (click)="hasSecondComparedPackage ? replacePackage(2) : null" [class.disabled]="!hasSecondComparedPackage">
          <button mat-button [disabled]="!hasSecondComparedPackage">
            <div class="btn-img-block">
              <img
                width="48"
                height="48"
                ngSrc="assets/img/i-circle-add.svg"
                alt=""
              />
              <span>{{
                'business-reserve-compare.select-compare-package' | translate
              }}</span>
            </div>
          </button>
        </div>
      }
    </div>
  </div>

  <!--固定按鈕區塊-->
  <div class="page-btn-block">
    <button
      mat-button
      class="btn-outline-primary btn-size-l"
      (click)="reSelectPackage()"
    >
      {{ 'business-reserve-compare.re-select-package' | translate }}
    </button>
  </div>
</div>
